import {Component, Input} from '@angular/core';
import {CompanyImageResponse, CompanyResponse, UserResponse} from '../../../../@shared/models/response.module';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {formatTimeYMD} from '../../../../@core/utils/utils.service';

import {
  EditUserProfile
} from '../../../user-profile/components/user-profile-overview/components/edit-user-profile/edit-user-profile';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {EditCompanyProfile} from './components/edit-company-profile/edit-company-profile';
import {EditCompanyImages} from './components/edit-company-images/edit-company-images';
import {CompanyService} from '../../../../@shared/services/company.service';
import {CarouselItem} from '../../../../@shared/components/carouselorini/carouselorini';



type EditorConstructor = {
  create(
    sourceElementOrData: string | HTMLElement,
    config?: Record<string, unknown>
  ): Promise<any>;
  EditorWatchdog: any;
};

@Component({
  selector: 'app-company-profile-overview',
  standalone: false,
  templateUrl: './company-profile-overview.html',
  styleUrl: './company-profile-overview.css'
})
export class CompanyProfileOverview {
  @Input() company: CompanyResponse
  companyImages: CompanyImageResponse[] = [];
  slides: CarouselItem[] = []

  constructor(private modal: NgbModal,
              private router: Router,
              private companyService: CompanyService) {
  }

  ngOnInit() {
    this.getCompanyImages()
  }

  openEditProfileModal() {
    let modalRef = this.modal.open(EditCompanyProfile, {size: 'lg', centered: true});
    modalRef.componentInstance.company = this.company;
    modalRef.result.then((result) => {
      if (result) {
      }
    })
  }

  openEditImagesModal() {
    let modalRef = this.modal.open(EditCompanyImages, {size: 'lg', centered: true});
    modalRef.componentInstance.company = this.company;
    modalRef.result.then((result) => {
      if (result) {
        this.getCompanyImages()
      }
    })
  }

  // Cast the build to the expected constructor type
  public Editor: EditorConstructor = ClassicEditor as unknown as EditorConstructor;

  onReady(editor: any) {
    console.log('CKEditor ready', editor);
  }

  getCompanyImages() {
    this.companyService.getCompanyImages({}).subscribe((res) => {
      this.companyImages = res;
      console.log("Company Images: ", res);
      for(let image of this.companyImages) {
        this.slides.push({imageUrl: image.image_url})
      }
    })
  }


  protected readonly formatTimeYMD = formatTimeYMD;
  protected readonly Date = Date;
}
